import { render, staticRenderFns } from "./my-password.vue?vue&type=template&id=118f81c7&scoped=true"
import script from "./my-password.vue?vue&type=script&lang=js"
export * from "./my-password.vue?vue&type=script&lang=js"
import style0 from "./my-password.vue?vue&type=style&index=0&id=118f81c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118f81c7",
  null
  
)

export default component.exports